"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setApplicationLogger = exports.getApplicationLogger = exports.Logger = exports.Level = void 0;
var Level;
(function (Level) {
  Level[Level["Silent"] = 0] = "Silent";
  Level[Level["Debug"] = 1] = "Debug";
  Level[Level["Default"] = 2] = "Default";
  Level[Level["Warning"] = 3] = "Warning";
  Level[Level["Error"] = 4] = "Error";
})(Level = exports.Level || (exports.Level = {}));
/**
 * @internal Used the defined the default applicationLogger
 */
var Logger = /*#__PURE__*/function () {
  function Logger() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '[react-celo]';
    _classCallCheck(this, Logger);
    this.namespace = namespace;
    if (!level) {
      if (process.env.DEBUG === 'true' || process.env.NODE_ENV !== 'production') {
        this.level = Level.Debug;
      } else {
        this.level = Level.Error;
      }
    } else {
      this.level = level;
    }
  }
  _createClass(Logger, [{
    key: "debug",
    value: function debug() {
      var _console;
      if (this.level > Level.Debug) return;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_console = console).info.apply(_console, [this.namespace].concat(args));
    }
  }, {
    key: "log",
    value: function log() {
      var _console2;
      if (this.level > Level.Default) return;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_console2 = console).log.apply(_console2, [this.namespace].concat(args));
    }
  }, {
    key: "warn",
    value: function warn() {
      var _console3;
      if (this.level > Level.Warning) return;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_console3 = console).warn.apply(_console3, [this.namespace].concat(args));
    }
  }, {
    key: "error",
    value: function error() {
      var _console4;
      if (this.level > Level.Error) return;
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      (_console4 = console).error.apply(_console4, [this.namespace].concat(args));
    }
  }]);
  return Logger;
}();
exports.Logger = Logger;
var applicationLogger = new Logger();
function setApplicationLogger(logger) {
  applicationLogger = logger;
}
exports.setApplicationLogger = setApplicationLogger;
function getApplicationLogger() {
  return applicationLogger;
}
exports.getApplicationLogger = getApplicationLogger;